import axios from 'axios'
import { BASE_URL } from './config'

const request = axios.create({ baseURL: BASE_URL })

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200) return res.data
    return Promise.reject(new Error(res.message || '请求失败'))
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token')
        window.location.href = '/login'
      }
      if (error.response.data && error.response.data.message) {
        return Promise.reject(new Error(error.response.data.message))
      }
    }
    return Promise.reject(error)
  }
)

// 认证
export const login = data => request.post('/auth/login', data)
export const register = data => request.post('/auth/register', data)
export const getAuthInfo = () => request.get('/auth/info')
export const updateProfile = data => request.post('/auth/profile', data)
export const changePassword = data => request.post('/auth/password', data)

// 字典
export const getDicts = () => request.get('/dict/all')

// 媒体
export const getMediaList = params => request.get('/media/list', { params })
export const getMediaDetail = params => request.get('/media/detail', { params })

// 自媒体
export const getWeMediaList = params => request.get('/we-media/list', { params })
export const getWeMediaDetail = params => request.get('/we-media/detail', { params })

// 文案代写
export const getCopywritingList = params => request.get('/copywriting/list', { params })
export const getCopywritingDetail = params => request.get('/copywriting/detail', { params })

// 视频媒体
export const getVideoMediaList = params => request.get('/video-media/list', { params })
export const getVideoMediaDetail = params => request.get('/video-media/detail', { params })

// 社交媒体
export const getSocialMediaList = params => request.get('/social-media/list', { params })
export const getSocialMediaDetail = params => request.get('/social-media/detail', { params })
export const getXiaohongshuMediaList = params => request.get('/xiaohongshu-media/list', { params })
export const getWechatMediaList = params => request.get('/wechat-media/list', { params })
export const getWeiboMediaList = params => request.get('/weibo-media/list', { params })

// 品牌营销
export const getBrandMarketingList = params => request.get('/brand-marketing/list', { params })
export const getBrandMarketingDetail = params => request.get('/brand-marketing/detail', { params })
export const getBrandTiebaMediaList = params => request.get('/brand-tieba-media/list', { params })
export const getBrandForumMediaList = params => request.get('/brand-forum-media/list', { params })
export const getBrandQaMediaList = params => request.get('/brand-qa-media/list', { params })
export const getBrandBaikeMediaList = params => request.get('/brand-baike-media/list', { params })
export const getBrandFriendlinkMediaList = params => request.get('/brand-friendlink-media/list', { params })

// 购物车
export const getCartList = params => request.get('/cart/list', { params })
export const toggleCart = data => request.post('/cart/toggle', data)
export const clearCart = () => request.post('/cart/clear')

// 收藏
export const getCollectList = params => request.get('/collect/list', { params })
export const toggleCollect = data => request.post('/collect/toggle', data)

// 收藏夹
export const getCollectFolders = params => request.get('/collect/folders', { params })
export const createCollectFolder = data => request.post('/collect/folder/create', data)
export const updateCollectFolder = data => request.post('/collect/folder/update', data)
export const deleteCollectFolder = data => request.post('/collect/folder/delete', data)


// 商家入驻
export const merchantRegister = data => request.post('/merchant/register', data)

// 用户提交入驻审核
export const submitMediaEntry = data => request.post('/media-entry/submit', data)

// 订单
export const createOrder = data => request.post('/order/create', data)
export const getOrderList = params => request.get('/order/list', { params })
export const getOrderDetail = params => request.get('/order/detail', { params })
export const payOrder = data => request.post('/order/pay', data)
export const cancelOrder = data => request.post('/order/cancel', data)
export const requestRefund = data => request.post('/order/requestRefund', data)
export const recharge = data => request.post('/order/recharge', data)
export const getFinanceList = params => request.get('/finance/list', { params })

// 发票
export const applyInvoice = data => request.post('/invoice/apply', data)
export const getInvoiceList = params => request.get('/invoice/list', { params })

// 充值支付
export const createRecharge = data => request.post('/payment/recharge', data)
export const queryRecharge = params => request.get('/payment/recharge/query', { params })
export const getRechargeList = params => request.get('/payment/recharge/list', { params })
export const createOrderPayment = data => request.post('/payment/order/create', data)
export const queryOrderPayment = params => request.get('/payment/order/query', { params })
